module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-17.74392700.png";